/* eslint-disable
    react/prefer-stateless-function,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import React from 'react';

class EntityName extends React.Component {
  render() {
    return (
      <a href={`/${this.props.entity.url_identifier}/`} target="_blank" rel="noopener noreferrer">
        {this.props.entity.name}
      </a>
    );
  }
}

export default EntityName;
